require('./hireCardAtHomeAbroadError.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @ commons
const WizardError = require('components/commons/wizardError/wizardError');

// @constants
const { catalogue, analyticsId } = require('../analytics/hireCardAtHomeAbroadAnalytics');

class HireCardAtHomeAbroadError extends React.Component {
    buildTexts() {
        const { immHireCardAtHomeAbroad, hireRestrictionFlag } = this.props;
        let errorMsg = immHireCardAtHomeAbroad.get('errorMsg');

        let titleKey;
        let textElement;
        if (!!errorMsg) {
            titleKey = 'hireCardAtHomeAbroad-errorTitleNotAllowed';
            textElement = <FormattedText value={`hireDebitErrors-${errorMsg}`} />
        } else {
            titleKey = 'hireCardAtHomeAbroad-errorTitleGeneric';
            textElement = <FormattedText value="hireCardAtHomeAbroad-errorTextGeneric" />
        }

        if(hireRestrictionFlag){
            titleKey = 'hireCard-errorRestrictionTitleAccount';
            textElement = <FormattedText value="hireCard-errorRestrictionSubtitleAccount" />
        }
        return {
            textElement,
            titleKey
        };
    }

    render() {
        const { processDetail, hireRestrictionFlag } = this.props;
        const { textElement, titleKey } = this.buildTexts();
        const goBackButton = hireRestrictionFlag ? {
            label: (
                <FormattedText
                    value="hireCard-errorRestrictionBackButtonText"
                />
            ),
            url: '/myprofile/global'
        }:{
            label: (
                <FormattedText
                    format="uppercase"
                    value="hireCardAtHomeAbroad-errorBackButtonText"
                />
            ),
            url: '/myprofile/global'
        };
        const cancleButton ={
            label: (
                <FormattedText
                    value="hireCard-errorRestrictionCancleButtonText"
                />
            ),
            url: '/myprofile/cards'
            };
        return (
            <WizardError
                errorMessage={formatText(titleKey)}
                mainButton={goBackButton}
                processDetail={processDetail}
                cancleButton={cancleButton}
                tealium={catalogue[analyticsId.AT_HOME_ABROAD_CARD_WIZARD_ERROR]({
                    productName: processDetail,
                    errorMessage: formatText(titleKey),
                })}
                isSecondVersion
            >
                <article className="hire-card-at-home-abroad-error">
                    {textElement}
                </article>
            </WizardError>
        );
    }
}

HireCardAtHomeAbroadError.propTypes = {
    immHireCardAtHomeAbroad: PropTypes.object.isRequired,
    processDetail: PropTypes.string,
    hireRestrictionFlag: PropTypes.bool
};

HireCardAtHomeAbroadError.defaultProps =
{
    hireRestrictionFlag : false
}

module.exports = HireCardAtHomeAbroadError;
